// extracted by mini-css-extract-plugin
export default {"subNav":"LabelAndMilestoneNavigation-module__subNav--Ac4rN","navLink":"LabelAndMilestoneNavigation-module__navLink--RCjRU"};